import React, { createContext } from "react";

export const FieldsContext = createContext();
/* export const BlurContext = createContext(); */
export const DataContext = createContext();
export const InvalidContext = createContext();
export const ListsContext = createContext();
